import {
  TranslationConcretingApprovalMessages,
  ConcretingApprovalMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingApprovalMessages = {
  [ConcretingApprovalMessages.stepDetailsText]: "Detalles",
  [ConcretingApprovalMessages.stepActionsText]: "Comportamiento",
  [ConcretingApprovalMessages.stepMessagesText]: "Mensajes",
  [ConcretingApprovalMessages.dialogTitleText]: "Aprobar Hormigonados",
  [ConcretingApprovalMessages.dialogButtonSubmitText]: "Confirmar",
  [ConcretingApprovalMessages.actionsObservationFieldLabel]: "Observación",
  [ConcretingApprovalMessages.actionsStatusFieldLabel]:
    "Estado de la hormigónado",
  [ConcretingApprovalMessages.concretingRequestStatusApproved]: "Aprobada",
  [ConcretingApprovalMessages.concretingRequestStatusRejected]: "Rechazada",
  [ConcretingApprovalMessages.concretingRequestStatusPending]: "Pendiente",
  [ConcretingApprovalMessages.messageInputPlaceholder]: "Escribe un mensaje"
};
